import { Button } from '@/ui/Button/Button';
import { Flex } from '@/ui/Flex/Flex';
import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

const StyledWrapper = styled(Flex)`
  background-color: ${({ theme }) => theme.color('#F2F0F0')};
  padding: 4px;
  border-radius: 8px;
`;

const StyledButton = styled(Button)`
  flex-grow: 1;
  flex-basis: 0;
  border-radius: 6px;

  ${({ mode }) =>
    mode === 'primary'
      ? css`
          pointer-events: none;
        `
      : null};
`;

type Props = {
  onSelectionChange: (newId: string) => void;
  selectedButton: string;
  buttons: {
    id: string;
    label: ReactNode;
  }[];
};

export const SwitchButton = ({
  selectedButton,
  onSelectionChange,
  buttons,
}: Props) => (
  <StyledWrapper>
    {buttons.map(({ id, label }) => (
      <StyledButton
        key={id}
        onClick={() => onSelectionChange(id)}
        mode={selectedButton === id ? 'primary' : 'transparent'}
      >
        {label}
      </StyledButton>
    ))}
  </StyledWrapper>
);
